import { render, staticRenderFns } from "./AccountsDetails.vue?vue&type=template&id=b22cc860&"
import script from "./AccountsDetails.vue?vue&type=script&lang=js&"
export * from "./AccountsDetails.vue?vue&type=script&lang=js&"
import style0 from "./AccountsDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports